import axios from "./AxiosInstance"

const getByAxis = (axisId, surveyParentId) => {
    let additionalUrl = ""
    if (surveyParentId > 0) {
        additionalUrl += `&surveyParentId=${surveyParentId}`
    }
    return axios.get(`api/surveys?axisId=${axisId + additionalUrl}&paginated=false`)
}

const getResponseTypes = () => axios.get(`api/widgets`)

const saveAnswers = (userId, responses) =>
    axios.post(`api/userSurveys/responses`, { userId, responses: [...responses] })

const getSurveyResponsesById = (userId, axisId, DEId) => {
    let additionalUrl = ""

    if (DEId) {
        additionalUrl += `&educationalDiagnosisId=${DEId}`
    }

    return axios.get(`api/userSurveys/axes/${axisId}/users/${userId}?paginated=false${additionalUrl}`)
}

export const SurveyService = {
    getByAxis,
    saveAnswers,
    getSurveyResponsesById,
    getResponseTypes
}
